import toast from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { editPublisher, editUser } from '../../../actions';
import config from '../../../../config';
import { addPrefixPhone } from '../../../utils/addPrefixPhone';
import { getAuthToken } from '../../../utils/auth';

const putFinanceDetail = async (publisherId, accessToken, payload) => {
  const response = await fetch(
    `${config.ApiBaseUrl}/publisher/${publisherId}/updateBranding`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    }
  );

  const json = await response.json();

  const { data, message, success } = json;

  if (!success)
    throw new Error(
      message ?? 'Something went wrong. failed to process request'
    );

  return data;
};

const putUserDetail = async (email, accessToken, payload) => {
  const response = await fetch(`${config.ApiBaseUrl}/user/${email}/edit`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const json = await response.json();

  const { data, message, success } = json;

  if (!success)
    throw new Error(
      message ?? 'Something went wrong. failed to process request'
    );

  return data;
};

const useSettings = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const publisherId = useSelector((state) => state.user.publisher?.id);

  const changeSettings = ({ name, logo, brand, email, phone }) => {
    const accessToken = getAuthToken();

    const payload1 = {
      financeEmail: email,
      financePhone: addPrefixPhone(phone),
      logoURL: logo,
      name: brand,
    };

    const payload2 = {
      implicitUnlock: true,
      name,
    };

    if (publisherId && accessToken) {
      toast.promise(
        Promise.all([
          putFinanceDetail(publisherId, accessToken, payload1),
          putUserDetail(email, accessToken, payload2),
        ]).then(([publisherDetails, userDetails]) => {
          dispatch(editPublisher(publisherDetails));
          dispatch(editUser({ ...user, ...userDetails }));
        }),
        {
          loading: 'saving...',
          success: 'settings saved!',
          error: 'Error while saving the settings!',
        }
      );
    }
  };

  return { changeSettings };
};

export default useSettings;
